import { StoriesFiltersType } from '@components/marketing/stories/grid/StoriesFilter'
import { makeBetweenFilter, makeFilter } from './crud/filters'
import { CommonStatusUILabel } from '@@partner:types:app'
import { BANNER } from '@hive/status'

export const prepareStoriesFilter = (filters: StoriesFiltersType) => {
  const nameFilter = makeFilter('name', 'includes', filters.name)
  const statusFilter = makeFilter('status', 'contains', filters.statuses)
  const activeFromFilter = makeBetweenFilter('activeFrom', filters.activeFrom)
  const activeUntilFilter = makeBetweenFilter('activeUntil', filters.activeUntil)
  
  return {
    and: [
      nameFilter,
      statusFilter,
      activeFromFilter,
      activeUntilFilter
    ]
  }
}

interface StoriesStatusUISettings extends CommonStatusUILabel {
  value: number
}

// Используем те же статусы что и для баннеров
export function getSearchableStoriesStatuses (): StoriesStatusUISettings[] {
  return [
    {
      label: 'Активен',
      value: BANNER.ENABLED,
      color: 'green'
    },
    {
      label: 'Неактивен',
      value: BANNER.DISABLED,
      color: 'red'
    }
  ]
}
